export const OPERAND_TYPE_VALUE = 'value';
export const OPERAND_TYPE_KEYWORD = 'keyword';
export const OPERAND_TYPE_FUNCTION = 'function';
export const OPERAND_TYPE_LIST = 'list';

export const OPERAND_EMPTY = 'empty';
